import { z } from 'zod';
/**
 * Delete Department Request Schema
 * DELETE /api/v2/departments/:id
 */ export const DeleteDepartmentRequestSchema = z.object({});
/**
 * Delete Department Response Schema
 * DELETE /api/v2/departments/:id
 */ export const DeleteDepartmentResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-department.schema.js.map